import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const features = [{
  id: "01",
  title: "Strategic Valuation",
  description: "We don't just price properties; we position them. Our data-driven valuations ensure you achieve the highest possible yield in the current UK market, maximizing your investment returns from day one."
}, {
  id: "02",
  title: "Vetted Tenant Network",
  description: "Quality over quantity. We rigorously screen every applicant to connect you with reliable, respectful tenants who treat your property like their own, ensuring peace of mind and consistent rental income."
}, {
  id: "03",
  title: "Proactive Asset Care",
  description: "Preserving your investment is our priority. From routine inspections to emergency repairs, our dedicated management team handles every detail, so you can enjoy the rewards of ownership without the stress."
}];
export default function TheLandlordEdge() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="the-landlord-edge" ref={ref} className="bg-background py-32 overflow-hidden relative">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {}
          <div className={cn("relative h-[600px] w-full rounded-sm overflow-hidden transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12")}>
            <div className="absolute inset-0 bg-gray-900/20 z-10 mix-blend-multiply pointer-events-none" />
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1572105/img/landlord_handshake_bw.png" alt="Professional handshake representing a trusted partnership" className="w-full h-full object-cover grayscale contrast-125 hover:scale-105 transition-transform duration-700 ease-in-out" />
          </div>

          {}
          <div className="flex flex-col gap-12 lg:gap-16">
            {features.map((feature, i) => <div key={feature.id} data-index={i} className={cn("group flex flex-col gap-4 transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")} style={{
            transitionDelay: `${i * 200}ms`
          }}>
                <span className="text-accent font-serif text-5xl md:text-6xl font-medium leading-none opacity-90">
                  {feature.id}
                </span>
                <div className="space-y-3">
                  <h3 className="text-foreground font-serif text-3xl md:text-4xl font-medium tracking-tight group-hover:text-accent transition-colors duration-300">
                    {feature.title}
                  </h3>
                  <p className="text-muted-foreground font-sans text-lg leading-relaxed max-w-md">
                    {feature.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}